import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import { Fields } from "@repoflow/components/fields";
import * as KeyAccess from "components/key-access";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>View</BreadcrumbItem>
  </>
);

export const Content = () => {
  const {
    values,
    schema, 
    base
  } = useSectionContext();


  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="float-right">

            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            target={{ $ref: "/Public/Key" }}
            widgets={KeyAccess.widgets}
            config={{
              "/Public/Key": {
                fields: KeyAccess.viewFields(values, ["description", "keyId", "roles"]),
              },
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};
